import {ChecklistRepository} from './ChecklistRepository';
import {ChecklistAPIDataSource} from '../api/ChecklistAPIDataSource';
import {Pagination} from '../../../Data/types/BaseResponse';
import {AppError, ErrorType} from '../../../Data/config/AppError';
import {PAGINATION_CONFIG} from '../../../constants/appConfig';
import {Checklist, ChecklistFilters, ChecklistPayload, ChecklistStatus, VisitChecklistSubmission} from '../models/checklist.model';

export class ChecklistRepositoryImpl implements ChecklistRepository {
  async list (
    page = 1,
    limit = PAGINATION_CONFIG.DEFAULT_PAGE_SIZE,
    filters?: ChecklistFilters
  ): Promise<{ items: Checklist[]; pagination?: Pagination }> {
    try {
      const res = await ChecklistAPIDataSource.list({page, limit, ...(filters || {})});
      return {
        items: Array.isArray(res.items) ? res.items : [],
        pagination: res.pagination
      };
    } catch (error) {
      if (error instanceof AppError) {
        throw error;
      }
      throw new AppError(
        'حدث خطأ أثناء جلب قوائم التحقق',
        ErrorType.UNKNOWN,
        undefined,
        undefined,
        error
      );
    }
  }

  async getById (id: number): Promise<Checklist> {
    try {
      return await ChecklistAPIDataSource.getById(id);
    } catch (error) {
      if (error instanceof AppError) {
        throw error;
      }
      throw new AppError(
        'حدث خطأ أثناء جلب قائمة التحقق',
        ErrorType.UNKNOWN,
        undefined,
        undefined,
        error
      );
    }
  }

  async create (payload: ChecklistPayload): Promise<Checklist> {
    try {
      return await ChecklistAPIDataSource.create(payload);
    } catch (error) {
      if (error instanceof AppError) {
        throw error;
      }
      throw AppError.fromApiError(error);
    }
  }

  async update (id: number, payload: ChecklistPayload): Promise<Checklist> {
    try {
      return await ChecklistAPIDataSource.update(id, payload);
    } catch (error) {
      if (error instanceof AppError) {
        throw error;
      }
      throw AppError.fromApiError(error);
    }
  }

  async setStatus (id: number, status: ChecklistStatus): Promise<Checklist> {
    try {
      return await ChecklistAPIDataSource.setStatus(id, status);
    } catch (error) {
      if (error instanceof AppError) {
        throw error;
      }
      throw AppError.fromApiError(error);
    }
  }

  async remove (id: number): Promise<void> {
    try {
      await ChecklistAPIDataSource.remove(id);
    } catch (error) {
      if (error instanceof AppError) {
        throw error;
      }
      throw AppError.fromApiError(error);
    }
  }

  async listVisitSubmissions (visitId: number): Promise<VisitChecklistSubmission[]> {
    try {
      return await ChecklistAPIDataSource.listVisitSubmissions(visitId);
    } catch (error) {
      if (error instanceof AppError) {
        throw error;
      }
      throw new AppError(
        'حدث خطأ أثناء جلب نتائج قوائم التحقق',
        ErrorType.UNKNOWN,
        undefined,
        undefined,
        error
      );
    }
  }
}
